import { v4 as uuidv4 } from 'uuid'

import { getConfiguration } from 'services/config'
import { getSanitizedContent } from 'utils/getSanitizedContent'

const cookieNames = {
  deviceId: 'device_id',
  promptEntry: 'promptEntry',
}

const sensitiveCookies = [cookieNames.promptEntry]

type SetCookieInput = {
  isPermanent?: boolean
  name: string
  value: string
}

const setCookie = ({ isPermanent, name, value }: SetCookieInput) => {
  let cookie = `${name}=${encodeURIComponent(value)}; path=/ai; samesite=lax`

  if (isPermanent) {
    const expires = new Date()
    expires.setFullYear(expires.getFullYear() + 1)
    cookie += `; expires=${expires.toUTCString()}`
  }

  document.cookie = cookie
}

const getCookie = (name: string) => {
  const cookieString = document.cookie
  const cookies = cookieString.split('; ')

  const value = cookies.map((cookie) => {
    const [cookieName, cookieValue] = cookie.split('=')
    if (cookieName != name) return undefined
    return getSanitizedContent(decodeURIComponent(cookieValue))
  }).filter(Boolean)

  return value.length > 0 ? value[0] : undefined
}

const clearCookie = (name: string) => {
  const { secureCookies } = getConfiguration()
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/ai;${secureCookies ? ' secure;' : ''}`
}

export const getPromptEntryCookie = () => getCookie(cookieNames.promptEntry)

export const getDeviceIdCookie = () => getCookie(cookieNames.deviceId)
export const clearSensitiveCookies = () => sensitiveCookies.forEach(cookie => clearCookie(cookie))

export const clearPromptEntryCookie = () => clearCookie(cookieNames.promptEntry)

export const initDeviceIdCookie = () => {
  if (getDeviceIdCookie()) return
  setCookie({ isPermanent: true, name: cookieNames.deviceId, value: uuidv4() })
}
